import styled from "styled-components";
import {
  color_grey_dark,
  color_grey_light,
  color_grey_ultra_dark,
  color_red_active,
  color_red_default,
  color_white,
} from "../../constants/colors";

const HELP_MOBILE = "(max-width: 640px)";

export const HelpSheet = styled.div`
  width: 520px;
  max-width: calc(100vw - 48px);
  max-height: calc(100dvh - 48px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 32px 32px 28px;
  overflow: hidden;
  background: ${color_white};
  border-radius: 32px;
  box-shadow: 0 24px 64px rgba(54, 54, 54, 0.16);

  @media ${HELP_MOBILE} {
    width: 100%;
    max-width: 100vw;
    max-height: min(92dvh, 760px);
    margin-top: auto;
    padding: 6px 20px calc(20px + env(safe-area-inset-bottom));
    border-radius: 28px 28px 0 0;
    box-shadow: 0 -12px 40px rgba(54, 54, 54, 0.12);
  }
`;

export const HelpHandle = styled.div`
  display: none;

  @media ${HELP_MOBILE} {
    display: block;
    width: 44px;
    height: 5px;
    border-radius: 99px;
    background: #cfcfcf;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
    flex-shrink: 0;
  }
`;

export const HelpHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 22px;

  @media ${HELP_MOBILE} {
    margin-bottom: 18px;
  }
`;

export const HelpHeaderCopy = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const HelpTitle = styled.h2`
  margin: 0;
  color: ${color_grey_ultra_dark};
  font: 700 26px/1.2 Onest, sans-serif;
  letter-spacing: -0.03em;

  @media ${HELP_MOBILE} {
    font-size: 22px;
  }
`;

export const HelpSubtitle = styled.p`
  margin: 0;
  color: #8a8a8a;
  font: 400 14px/1.4 Onest, sans-serif;

  @media ${HELP_MOBILE} {
    font-size: 13px;
  }
`;

export const HelpCloseButton = styled.button`
  width: 38px;
  height: 38px;
  flex: 0 0 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  background: #f5f5f5;
  color: ${color_grey_ultra_dark};
  cursor: pointer;

  &:hover {
    background: #ececec;
  }

  &:focus-visible {
    outline: 2px solid rgba(240, 79, 79, 0.3);
    outline-offset: 3px;
  }
`;

export const HelpForm = styled.form`
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: auto;
`;

export const HelpFieldsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media ${HELP_MOBILE} {
    grid-template-columns: 1fr;
    gap: 14px;
  }
`;

export const HelpField = styled.label`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: ${color_grey_ultra_dark};
  font: 400 13px/1.3 Onest, sans-serif;
`;

export const HelpInput = styled.input`
  width: 100%;
  height: 56px;
  padding: 0 16px;
  border: 1px solid #e8e8e8;
  border-radius: 16px;
  outline: none;
  background: ${color_white};
  color: ${color_grey_ultra_dark};
  box-sizing: border-box;
  font: 400 16px/1 Onest, sans-serif;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &::placeholder {
    color: ${color_grey_dark};
  }

  &:hover:not(:disabled) {
    border-color: #dedede;
  }

  &:focus {
    border-color: ${color_red_default};
    box-shadow: 0 0 0 3px rgba(240, 79, 79, 0.16);
  }
`;

export const HelpTextarea = styled.textarea`
  width: 100%;
  min-height: 220px;
  height: 260px;
  padding: 16px 16px;
  border: 1px solid #e8e8e8;
  border-radius: 16px;
  outline: none;
  resize: vertical;
  background: ${color_white};
  color: ${color_grey_ultra_dark};
  box-sizing: border-box;
  font: 400 16px/1.45 Onest, sans-serif;
  overflow-wrap: anywhere;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  &::placeholder {
    color: ${color_grey_dark};
  }

  &:hover:not(:disabled) {
    border-color: #dedede;
  }

  &:focus {
    border-color: ${color_red_default};
    box-shadow: 0 0 0 3px rgba(240, 79, 79, 0.16);
  }

  @media ${HELP_MOBILE} {
    min-height: 180px;
    height: 200px;
    resize: none;
  }
`;

export const HelpPhoneWrap = styled.div`
  min-width: 0;

  .FormPhoneInput-wrapper {
    width: 100% !important;
    gap: 8px !important;
    color: ${color_grey_ultra_dark};
    font: 400 13px/1.3 Onest, sans-serif;
  }

  .FormPhoneInput-wrapper > *:first-child {
    font: 400 13px/1.3 Onest, sans-serif !important;
  }

  .FormPhoneInput {
    width: 100% !important;
    min-width: 0 !important;
    max-width: none !important;
    height: 56px;
    padding: 0 8px 0 12px !important;
    border: 1px solid #e8e8e8 !important;
    border-radius: 16px !important;
    background: ${color_white} !important;
    box-sizing: border-box;
    overflow: hidden;
  }

  .PhoneInputInput {
    height: 54px !important;
    padding: 0 8px 0 4px !important;
    font-size: 16px !important;
    background: transparent !important;
  }

  .FormPhoneInput:focus-within {
    border-color: ${color_red_default} !important;
    box-shadow: 0 0 0 3px rgba(240, 79, 79, 0.16);
  }
`;

export const HelpSubmit = styled.button`
  width: 100%;
  height: 56px;
  margin-top: 4px;
  border: 0;
  border-radius: 999px;
  background: ${(props) => (props.disabled ? color_grey_light : color_red_default)};
  color: ${color_white};
  font: 600 16px/1 Onest, sans-serif;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition:
    background 0.15s ease,
    transform 0.15s ease,
    box-shadow 0.15s ease;

  &:hover:not(:disabled) {
    background: ${color_red_active};
    box-shadow: 0 8px 20px rgba(240, 79, 79, 0.2);
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:focus-visible {
    outline: 3px solid rgba(240, 79, 79, 0.25);
    outline-offset: 3px;
  }

  @media ${HELP_MOBILE} {
    height: 56px;
    margin-top: 8px;
  }
`;
